export class EventTicketsConstants {
  public static EVENT_TICKETS = 'event-tickets'
  public static EVENT_DETAILS = 'event-details'
  public static EVENT_TICKETS_LIST = 'event-tickets-list'
  public static GUESTS = 'guests'
  public static CREATE_TICKET = 'create-ticket'
  public static EDIT_TICKET = 'edit-ticket'
  public static BULK_UPDATE = 'bulk-update'
  public static PURCHASES_LIST = 'purchases-list'
  public static QUESTIONS = 'questions'
  public static TICKETING_QUESTIONS = 'ticketing-questions'
  public static TABLES = 'tables'
  public static DISCOUNT_CODES = 'discount-codes'
}
